import * as React from 'react';
import { EditComponent, CustomComponentProps, CreateComponent } from 'src/components/common/Component';

export function AttributeSetEditComponent(props: CustomComponentProps) {
    const { children } = props;
    return (
        <EditComponent attributes={["name"]} children={children} />
    );
}

export function AttributeSetCreateComponent(props: CustomComponentProps) {
    const { children } = props;
    return (
        <CreateComponent source={"attribute set"} children={children} />
    );
}